import React from 'react';
import NextImage from 'next/image';
import NextLink from 'next/link';
import {
  Box,
  Container,
  Flex,
  HStack,
  Link,
  Spacer,
  useColorMode,
} from '@chakra-ui/react';
import { sendAnalyticsEvent } from '../common/libs/googleAnalytics';

export default function NavBarSimple() {
  const { colorMode } = useColorMode();
  return (
    <Flex
      bg="navbar"
      py={26}
      px={[17, null, null, 39]}
      shadow="navbar"
      borderBottomColor={'navbarBottom'}
      borderBottomWidth={1}
      pos="fixed"
      zIndex={99}
      height={['56px', null, null, '70px']}
      width="100vw"
      alignItems="center"
    >
      <Container py={1}>
        <HStack>
          <Link
            href="/"
            display="flex"
            translateY="2px"
            transform="auto"
            flexShrink={0}
          >
            <Box height={[25, null, null, 33]} width={[122, null, null, 164]}>
              <NextImage
                src={
                  colorMode === 'light'
                    ? '/images/logo_slide.png'
                    : '/images/logo_slide_white.png'
                }
                alt="Antaa Slide"
                layout="fill"
                objectFit="contain"
              />
            </Box>
          </Link>
          <Spacer />
          <NextLink href="/login" passHref>
            <Link
              minW="70px"
              fontSize="sm"
              // 2026-10-09：ログインボタン文言変更施策
              onClick={() =>
                sendAnalyticsEvent(
                  'link_to',
                  'click',
                  'login_or_signup_simple_20261009',
                )
              }
            >
              登録 / ログイン
            </Link>
          </NextLink>
        </HStack>
      </Container>
    </Flex>
  );
}
